import { InjectionToken } from '@angular/core';

export interface PaymentCardConfig {
  vertical?: boolean;
}

export const PAYMENT_CARD_CONFIG_TOKEN = new InjectionToken<PaymentCardConfig>('PAYMENT_CARD_CONFIG_TOKEN');
